module.exports = __webpack_public_path__ + "img/settings2.08db2d53.png";